module.exports = __webpack_public_path__ + "static/forecast/forecast-sunrise-9921526af7e1d9bab07afbef52e6e540.svg";